export default "__VITE_ASSET__CECK9Y2r__"